import { MembersCustomPageManagedByWixAppId } from '@wix/a11y-wizard-common';
export let MembershipCustomPageType = /*#__PURE__*/function (MembershipCustomPageType) {
  MembershipCustomPageType["SignUp"] = "signUp";
  MembershipCustomPageType["SignIn"] = "signIn";
  return MembershipCustomPageType;
}({});
const createMockMembersCustomPage = (pageId, title, type) => ({
  id: pageId,
  managedByWixAppId: type === MembershipCustomPageType.SignUp ? MembersCustomPageManagedByWixAppId.SignUp : MembersCustomPageManagedByWixAppId.SignIn,
  security: {},
  staticPage: {
    uri: `/membership-page/${pageId}`
  },
  title
});
const addMembersCustomPageIfNeeded = (pageId, title, type, allPages) => {
  if (!allPages.find(p => p.id === pageId)) {
    return createMockMembersCustomPage(pageId, title, type);
  }
  return null;
};
export const addMembersCustomPages = (allPages, a11yWizardAdapter) => {
  if (a11yWizardAdapter.getMembersCustomPages) {
    const customPages = a11yWizardAdapter.getMembersCustomPages();
    const membershipPages = [];
    if (customPages != null && customPages.signUp.id) {
      const signUpPage = addMembersCustomPageIfNeeded(customPages.signUp.id, customPages.signUp.title, MembershipCustomPageType.SignUp, allPages);
      if (signUpPage) {
        membershipPages.push(signUpPage);
      }
    }
    if (customPages != null && customPages.signIn.id) {
      const signInPage = addMembersCustomPageIfNeeded(customPages.signIn.id, customPages.signIn.title, MembershipCustomPageType.SignIn, allPages);
      if (signInPage) {
        membershipPages.push(signInPage);
      }
    }
    if (membershipPages.length > 0) {
      return [...allPages, ...membershipPages];
    }
  }
  return allPages;
};
//# sourceMappingURL=create-members-custom-page-data.js.map